// extracted by mini-css-extract-plugin
export default {"oneClickButtonWrapper":"oneClickButtonWrapper__u7uIi","onyx":"onyx__j1liW","oneClickLegalWrapper":"oneClickLegalWrapper__PnmYw"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"oneClickButtonWrapper\":\"oneClickButtonWrapper__u7uIi\",\"onyx\":\"onyx__j1liW\",\"oneClickLegalWrapper\":\"oneClickLegalWrapper__PnmYw\"}";
        // 1787130556923
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  